import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';
import es from 'vee-validate/dist/locale/es';
import VeeValidate, { Validator } from "vee-validate";
import ElementLoading from 'vue-element-loading';
import DatePicker from 'vue2-datepicker';
import axios from 'axios';
import toastr from 'toastr';
import moment from 'moment';
import VueMoment from 'vue-moment';

import Kilometros from './views/Kilometros.vue';
/*import NuevoProyecto from './components/Proyectos/NuevoProyecto.vue';
import EntrevistaInicialSocial from './components/EntrevistaInicial/EntrevistaInicialSocial.vue';
import EntrevistaSocialB from './components/EntrevistaInicial/EntrevistaSocialB.vue';
import Cotizacion from './components/Cotizacion.vue';
import Honorarios from './components/Honorarios.vue';
import Contrato from './components/Contrato.vue';
import FormularioInvitados from './components/Invitados/FormularioInvitados.vue';
import Layout from './components/Layout/Layout.vue';
import Musica from './components/Musica/FormularioMusical.vue';
import Rider from './components/Rider.vue';
import Itinerarios from './components/Itinerarios/Itinerarios.vue';
import Cortejo from './components/Cortejo.vue';
import Recoger from './components/Recoger.vue';
import Encuesta from './components/Encuesta.vue';*/

Vue.component('VueElementLoading', ElementLoading);
require('moment/locale/es');
Vue.use(VueMoment,{moment});
Vue.component('DatePicker', DatePicker);
import Multiselect from 'vue-multiselect';
Vue.component('multiselect', Multiselect);
/*Vue.component('NuevoProyecto', NuevoProyecto);
Vue.component('EntrevistaInicialSocial', EntrevistaInicialSocial);
Vue.component('EntrevistaSocialB', EntrevistaSocialB);
Vue.component('Cotizacion', Cotizacion);
Vue.component('Honorarios', Honorarios);
Vue.component('Contrato', Contrato);
Vue.component('FormularioInvitados', FormularioInvitados);
Vue.component('Layout', Layout);
Vue.component('Musica', Musica);
Vue.component('Rider', Rider);
Vue.component('Itinerarios', Itinerarios);
Vue.component('Cortejo', Cortejo);
Vue.component('Recoger', Recoger);
Vue.component('Encuesta', Encuesta);*/

window.axios = axios;
window.router = router;
toastr.options = { "progressBar": true, "newestOnTop": true, "positionClass": "toast-bottom-right", "closeButton": true,};
window.toastr = toastr;//TODO Zkalish aqui estan las url!
window.url  = 'https://rastreo.geovoy.com/api/';
window.url2 = 'https://rastreo.geovoy.com:4000/api/';
window.url3 = 'https://geovoy.com/cargacarga/apicargacarga/';
// window.token = response.body.token;

const config = {
  aria: true,
  classNames: { valid: 'is-valid', invalid: 'is-invalid'},
  classes: true,
  delay: 0,
  dictionary: null,
  errorBagName: 'errors', // change if property conflicts
  events: 'input|blur|change|keyup',
  fieldsBagName: 'fields',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  inject: true,
  locale: 'es',
  validity: true,
  useConstraintAttrs: true
};
Vue.filter('formatDate',function (value) {
if(value){
  return moment(String(value)).format('MM/DD/YYYY HH:mm:ss')
}

});

Vue.use(VeeValidate, config);
Validator.localize("es", es);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
